import { ATTRIBUTE_TYPE_MULTI_SELECT, ATTRIBUTE_TYPE_SINGLE_SELECT, ATTRIBUTE_TYPE_TEXT } from "./constant";

export const formatAdditionalAttributesForPayload = (
  data = {},
  attributeFields = []
) => {

  const formattedData = { ...data };

  attributeFields.forEach((field) => {

    const value = data?.[field];

    // NULL / UNDEFINED
    if (value == null) {
      formattedData[field] = "";
      return;
    }

    // ARRAY
    // ["option1", "option2"]
    if (Array.isArray(value)) {

      formattedData[field] = value
        .map((item) => {

          // OBJECT
          if (typeof item === "object") {
            return item?.name || "";
          }

          // STRING
          return item;
        })
        .filter(Boolean)
        .join(",");

      return;
    }

    // OBJECT
    // {name:"option1"}
    if (typeof value === "object") {

      formattedData[field] = value?.name || "";

      return;
    }

    // STRING / NUMBER
    formattedData[field] = value;
  });

  return formattedData;
};

export const getFormattedAdditionalAttributeValue = ({
  type,
  value,
  options = [],
}) => {

  // TEXT
  if (type === ATTRIBUTE_TYPE_TEXT) {
    return value ?? "";
  }

  // SINGLE SELECT
  if (type === ATTRIBUTE_TYPE_SINGLE_SELECT) {

    if (!value) return null;

    return (
      options.find(
        (option) => option?.name === value
      ) || null
    );
  }

  // MULTI SELECT
  if (type === ATTRIBUTE_TYPE_MULTI_SELECT) {

    if (!value) return [];

    // option1,option2
    const splitValues =
      typeof value === "string"
        ? value.split(",")
        : value;
    return options.filter((option) =>
      splitValues.includes(option?.name)
    );
  }

  return value ?? "";
};